import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import VueBus from "vue-bus";
import axios from "axios";
import qs from "qs";
import UTILS from "../utils/utils";
Vue.use(VueBus);

Vue.use(Router);
function simpleMetaInfo(title, keepAlive, requiresAuth) {
	return {
		metaInfo: {
			title: title
		},
		keepAlive: keepAlive ? true : false,
		requiresAuth: requiresAuth ? true : false
	};
}

const router = new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			component: () => import("../views/Home.vue"),
			meta: simpleMetaInfo("Yctop")
		},
		{
			path: "/tool",
			component: () => import("../views/tool/index.vue"),
			meta: simpleMetaInfo("Air transport tools"),
			children: [
				{
					path: "airport_code",
					component: () =>
						import("../views/tool/tool_detail/airport_code.vue"),
					meta: simpleMetaInfo("Airport code", true)
				},
				{
					path: "airline_info",
					component: () =>
						import("../views/tool/tool_detail/airline_info.vue"),
					meta: simpleMetaInfo("Flight information", true)
				},
				{
					path: "hs_code",
					component: () => import("../views/tool/tool_detail/hs_code.vue"),
					meta: simpleMetaInfo("HS code", true)
				},
				{
					path: "tact",
					component: () => import("../views/tool/tool_detail/tact.vue"),
					meta: simpleMetaInfo("TACT enquiry", true)
				},
				{
					path: "plane_type",
					component: () => import("../views/tool/tool_detail/plane_type.vue"),
					meta: simpleMetaInfo("Aircraft type", true)
				}
			]
		},
		{
			name: "TrackPage",
			path: "/track",
			component: () => import("../views/tool/track.vue"),
			meta: simpleMetaInfo("Cargo tracking")
		},
		{
			path: "/product/starList",
			component: () => import("../views/product/starList.vue"),
			meta: simpleMetaInfo("HOT")
		},
		{
			name: "ProductQueryPage",
			path: "/product/query",
			component: () => import("../views/product/query.vue"),
			meta: simpleMetaInfo("International air freight")
		},
		{
			name: "ProductDetailPage",
			path: "/product/detail",
			component: () => import("../views/product/detail.vue"),
			meta: simpleMetaInfo("Product details")
		},
		{
			path: "/user",
			component: () => import("@/views/user/index.vue"),
			children: [
				{
					path: "login",
					component: () => import("../views/user/login.vue"),
					meta: simpleMetaInfo("Sign in")
				},
				{
					path: "register",
					component: () => import("../views/user/register.vue"),
					meta: simpleMetaInfo("Sign up")
				},
			]
		},
		{
				path: '/incidentals',
				component: () => import('@/views/about/incidentals.vue'),
				meta: simpleMetaInfo('Port fees-yctop.com'),
		},
		{
			path: '/yc',
			component: () => import('@/views/about/yc.vue'),
			meta: simpleMetaInfo('About us-yctop.com'),
	},
		{
				path: '/compatibility',
				component: () => import('@/views/compatibility.vue'),
				meta: simpleMetaInfo('Compatible-yctop.com'),
		},
		{
			path: "*",
			component: () => import("@/views/notfound.vue"),
			meta: simpleMetaInfo("404")
		}
	]
});
router.beforeEach((to, from, next) => {
	if (to.meta.metaInfo) store.commit("CAHNGE_META_INFO", to.meta.metaInfo);
	next();
});

router.beforeEach(async (to, from, next) => {
	await store.dispatch("initDB");
	next();
});

router.afterEach(async (to, from) => {
	let query = to.query || {},
		queryUrl = UTILS.obj2UrlQuery(query),
		obj = {}
	obj.from = (from.path)
	obj.to = (to.path + queryUrl)
	let uuid = getCookie('g_efreight_uid') || ''
	if(!uuid) {
		uuid = UTILS.uuid().replace(/-/g, '')
		document.cookie = "g_efreight_uid=" + uuid
	}
	obj.uuid = uuid
	obj.v = "0.1.2"
	obj.ds = window.screen.width + 'X' + window.screen.height
	try {
		let header = {};
		header['Content-Type']= 'application/x-www-form-urlencoded';
		await axios.post('/hm.gif', qs.stringify(obj), { headers: header})
	} catch (err) {

	}

});

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
         }
         if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
         }
     }
    return "";
} 

export default router;
